import './Checkout.css'
import Star from "@material-ui/icons/Star"
import Halfstar from "@material-ui/icons/StarHalf"
import { useDispatch } from "react-redux"

export default function Checkout({ id, prdName, image, price, review, buttonCart }) {
    let dispatch = useDispatch();
    return (

        <div className="checkout">
            <div className="checkout_main">
                <div className="checkout_image">
                    <img src={image} />
                </div>

                <div className="checkout_info">
                    <p className="checkout_title"> {prdName} </p>
                    <p className="checkout_price"> {price}</p>

                    <div className="checkout_review">
                        <Star className="star" />
                        <Star className="star" />
                        <Star className="star" />
                        <Star className="star" />
                        <Halfstar className="star" />
                        {review}
                    </div>
                    <span className="prd__cart"><button className='prd4__btn' onClick={() => dispatch({ type: "REMOVE_PRODUCT", id: id })} >Remove from Cart</button></span>

                </div>
            </div>


        </div>



        // <div>


        // <div className="stdiv">

        //     <div className="prd">
        //      <span><strong>{prdName}</strong></span>
        //      <div className="prd__img">
        //         <img className="img1" src={img} />
        //     </div>
        //     <span><strong>{price}</strong></span>
        //     <div className="prd__star">
        //         <Star className="star"/>
        //         <Star className="star"/>
        //         <Star className="star"/>
        //         <Star className="star"/>
        //         <Halfstar className="star"/>

        //         <span className="prd__review"><strong>{review}</strong></span>


        //     </div>

        //     <span className="prd__cart"><button className='prd4__btn' >{buttonCart}Remove from Cart</button></span>

        //     </div>

        // </div>
        // </div>
    )
}
